<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emSppWarehousingSpwResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" ref="emTable"
                                      withCustomRowActions import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">

                              <template #left-header>
                                <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-arrow-down"
                                           custom-label="勾选入库"
                                           v-bind:class="'btn btn-outline-primary btn-sm'"
                                           @click="entryStorage">
                                </em-button>
                              </template>

                              <template #customRowActions="{row}">
                                <b-button-group>
                                  <em-button type="gotoChild"
                                             v-bind:class="'btn btn-outline-primary btn-sm'"
                                             @click="gotoChild(row)" custom-label="转到入库单详情">
                                  </em-button>
                                </b-button-group>
                              </template>

                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author thq
    // Date 2020-12-13 22:12:58

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import emApiMixin from "@/mixin/em/common/api";
    import commonViewsUtil from "@/utils/commonViewsUtil";


    export default {
        name: "emSppWarehousingSpwListView",
      mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            },
            selectIds() {
              return this.$store.state[this.modelName]["checkedItems"].join(",")
            },
            entityBaseUrl() {
              return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
            }
        },
        methods: {
          gotoChild(row) {
            this.$_emGotoMixin_gotoHolderList(
                "emSppWarehousingDetSwd",
                {swdIdSpwFilter: row.id},
                {swdIdSpw: row.id},
                false,
                {mainId:row.id}
                )
          },
          entryStorage(){
            if(this.selectIds == null || this.selectIds == ""){
              alert("请勾选入库单操作入库！")
              return;
            }
            let url = `${this.entityBaseUrl}entryStorage`
            console.log("入库的API接口：" + url)
            console.log("打印出勾选的IDs：" + this.selectIds)  //selectIds 上面computed里调用，抽取所有勾选的ID
            this.$_emApiMixin_post(url, {headerIds: this.selectIds})
            .then(response => {
                  console.log("返回的数据：" + response.body)
                  commonViewsUtil.showSuccess(this, "入库成功")
                  this.$refs.emListFilter.doQuery()
                }
            )
          }
        }
    };
</script>